import { bound } from "@frui.ts/helpers/dist";
import { Router } from "@frui.ts/screens";
import { Modules } from "config";
import type Enum from "entities/enum";
import Municipality from "entities/municipality";
import EnumRepository from "repositories/enumRepository";
import ConfirmationService from "services/confirmationService";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import SecurityService from "services/securityService";
import Region from "entities/region";
import OptionsService from "services/optionsService";
import ListViewModel from "viewModels/listViewModel";
import MunicipalityCreateViewModel from "./municipalityCreateViewModel";
import MunicipalityDetailViewModel from "./municipalityDetailViewModel";

const navigationName = "municipalities";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [MunicipalityCreateViewModel, MunicipalityDetailViewModel],
})
export default class MunicipalitiesViewModel extends ListViewModel<
  Municipality,
  MunicipalityDetailViewModel,
  MunicipalityCreateViewModel
> {
  readonly modelName = "municipality";

  constructor(
    protected createViewModelFactory: () => MunicipalityCreateViewModel,
    protected detailViewModelFactory: ReturnType<typeof MunicipalityDetailViewModel.Factory>,
    protected repository: EnumRepository,
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected notificationService: NotificationService,
    protected confirmationService: ConfirmationService,
    protected optionsService: OptionsService,
    protected securityService: SecurityService
  ) {
    super();
    this.navigationName = navigationName;
  }

  protected fetchData() {
    return this.repository.postAll("municipalities", Municipality, {});
  }

  @bound
  regionName(regionId: string) {
    return this.optionsService.entityOptions(Region).find(region => region.id === regionId)?.label ?? "";
  }

  delete(item: Enum): any {
    return this.repository.delete(item, "municipalities");
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.timeCharges, `municipalities.${code}`, size);
  }
}
